<template>
    <div> 
        <div v-if='in_stock' class="lock-it-in-buttons">
            <Button class="lock-it-in-button" :disabled='is_disabled' text='Lock In 6 bottles' theme='green' @click='addQuantity(6)'/>
            <Button class='lock-it-in-button' :disabled='is_disabled' text='Lock In 12 bottles' theme='dark' @click='addQuantity(12)'/>
        </div>
        <div class='successfully-added-to-bag-container'>
            <Tooltip :tooltip_queue='tooltip_queue'/>
        </div>
    </div>
</template>
<script>
import {checkAuth, fireCartEvent, fireOmetriaBasketEvent} from "@/global/modules/functions.js";
import Button from '@/ecom/components/buttons/Button.vue';
import Tooltip from '@/ecom/components/popups/Tooltip.vue';

export default {
    components: {Button, Tooltip},
    props: ['product', 'in_stock', 'variant_code', 'item_quantity'],
    emits: ['updatedCartListener', 'addToCartListener'],
    data(){
        return{
            quantity: 0,
            tooltip_queue: [],
            is_disabled: false
        }
    },
    methods:{
        addQuantity(quantity) {
            this.quantity += quantity;
            this.addToCart(quantity);
        },
        async addToCart(change_quantity){
            let response = await fetch(`/api/lock-it-in/cart/update`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    product: this.product,
                    quantity: this.quantity,
                    type: 'override_quantity'
                }),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                if(!results.stock.in_stock) {
                    let out_of_stock_message = '';
                    if(results.stock.left_in_stock > 0) {
                        out_of_stock_message = 'There are only ' + results.stock.left_in_stock  + ' of this item left in stock';
                    } else if(results.stock.left_in_stock == 0){
                        out_of_stock_message = 'This item is out of stock';
                    }
                    this.tooltip_queue.push({text: out_of_stock_message});
                    this.is_disabled = true;
                } else {
                    this.tooltip_queue.push({text: 'Added to bag!'});
                    fireCartEvent(this.product, change_quantity, 'add_to_cart', 'lock-it-in');
                    fireOmetriaBasketEvent(results.cart, 'lock_it_in');
                }
                this.$emit('updatedCartListener');
                this.$emit('addToCartListener', this.product, this.quantity);
            }
        }
    },
    watch: {
        'product': {
            handler() {
                this.quantity = this.product.locked_in ? this.item_quantity : 0;
            },
            deep: true
        }
    }
}
</script>
<style lang="scss" scoped>
.lock-it-in-buttons{
    display:flex;
    flex-wrap: wrap;
    gap: 20px;
    @media(max-width:479px) {
        justify-content: center;
    } 
}
.lock-it-in-button{
    width: 180px;
}
.successfully-added-to-bag-container{
    display: flex;
    justify-content: center;
}
</style>